// Dashboard & Settings are base-app, not paid add-ons -- always on for
// every tenant, never toggleable or priced. Shared here so
// SuperadminDashboard's tile grid and SuperadminPricing's rate tiles can't
// drift apart on which module keys count as "core".
export const CORE_MODULE_KEYS = ['dashboard', 'settings'];
